import React, { FC } from "react";
import { Asset, Entry } from "contentful";
import useStorefrontApi from "../../hooks/useStorefrontApi";
import BaseCollectionTile from "./BaseCollectionTile";

interface ShopifyCollectionTileProps extends Entry {
  id: string,
  fields: {
    shopifyCollection: string;
    customTitle?: string;
    description?: string;
    imageAsset?: Asset;
    hoverAsset?: Asset;
    tileType: string;
    brand: string;
  }
}

const getCollectionQuery = (shopifyCollectionId: string) => `
  query {
    collection(id: "${shopifyCollectionId}") {
      title
      handle
      image {
        url
      }
    }
  }
`;

const ShopifyCollectionTile: FC<ShopifyCollectionTileProps> = ({ id, fields: {
  shopifyCollection,
  customTitle,
  description,
  imageAsset,
  hoverAsset,
  tileType,
  brand
} }) => {
  if (!shopifyCollection) return null;

  const query = getCollectionQuery(shopifyCollection);
  const { storefrontData } = useStorefrontApi(query);
  // @ts-ignore
  if (!storefrontData?.collection) return null;

  // @ts-ignore
  const { title, handle, image } = storefrontData.collection;
  const href = `/collections/${handle}`;

  let imageUrl = '';
  // Prefer the Contentful image field to the native Shopify image.
  // Todo: What if neither are provided? Generic fallback?
  if (imageAsset && imageAsset.fields.file) {
    imageUrl = `https:${imageAsset.fields.file.url}`;
  } else if (image && image.url) {
    imageUrl = imageUrl;
  }

  return (
    <BaseCollectionTile
      componentId={id}
      description={description}
      hoverImageUrl={hoverAsset?.fields?.file?.url as string}
      href={href}
      imageUrl={imageUrl}
      title={customTitle || title}
      tileType={tileType}
      brand={brand}
    />
  );
}

export default ShopifyCollectionTile;